(function () {
    'use strict';

    angular.module("imApp").factory("freightRateTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1537,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1538,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
